import { Sides } from "@project/emerge-types";
import * as THREE from "three";
import type { RectProperties } from "../interfaces/RectProperties";

export const RectPropertiesBySide: Record<Sides, RectProperties> = {
  [Sides.FRONT]: {
    horizontal: "x",
    horizontalDir: new THREE.Vector3(1, 0, 0),
    left: Sides.LEFT,
    normal: "z",
    normalDir: new THREE.Vector3(0, 0, 1),
    top: Sides.TOP,
    vertical: "y",
    verticalDir: new THREE.Vector3(0, 1, 0),
  },
  [Sides.BACK]: {
    horizontal: "x",
    horizontalDir: new THREE.Vector3(-1, 0, 0),
    left: Sides.RIGHT,
    normal: "z",
    normalDir: new THREE.Vector3(0, 0, -1),
    top: Sides.TOP,
    vertical: "y",
    verticalDir: new THREE.Vector3(0, 1, 0),
  },
  [Sides.BOTTOM]: {
    horizontal: "x",
    horizontalDir: new THREE.Vector3(1, 0, 0),
    left: Sides.LEFT,
    normal: "y",
    normalDir: new THREE.Vector3(0, -1, 0),
    top: Sides.FRONT,
    vertical: "z",
    verticalDir: new THREE.Vector3(0, 0, 1),
  },
  [Sides.TOP]: {
    horizontal: "x",
    horizontalDir: new THREE.Vector3(1, 0, 0),
    left: Sides.LEFT,
    normal: "y",
    normalDir: new THREE.Vector3(0, 1, 0),
    top: Sides.BACK,
    vertical: "z",
    verticalDir: new THREE.Vector3(0, 0, -1),
  },
  [Sides.LEFT]: {
    horizontal: "z",
    horizontalDir: new THREE.Vector3(0, 0, 1),
    left: Sides.BACK,
    normal: "x",
    normalDir: new THREE.Vector3(-1, 0, 0),
    top: Sides.TOP,
    vertical: "y",
    verticalDir: new THREE.Vector3(0, 1, 0),
  },
  [Sides.RIGHT]: {
    horizontal: "z",
    horizontalDir: new THREE.Vector3(0, 0, -1),
    left: Sides.FRONT,
    normal: "x",
    normalDir: new THREE.Vector3(1, 0, 0),
    top: Sides.TOP,
    vertical: "y",
    verticalDir: new THREE.Vector3(0, 1, 0),
  },
};
